export default __webpack_public_path__ + "static/media/filter_status_light.918f479f.svg";